import React from 'react'

const Instructions = () => {
  const scrollToCardboard = () => {
    const target = document.getElementById('cardboard-instructions')
    target?.scrollIntoView({ behavior: 'smooth' })
  }

  return (
    <section className='instructions-section' style={{ padding: '2rem', fontFamily: 'sans-serif', lineHeight: 1.6 }}>
      {/* Scroll Button */}
      <div style={{ textAlign: 'center', marginBottom: '2rem' }}>
        <button
          onClick={scrollToCardboard}
          style={{
            backgroundColor: '#ff6f61',
            color: '#fff',
            padding: '12px 24px',
            border: 'none',
            borderRadius: '6px',
            fontSize: '1rem',
            cursor: 'pointer'
          }}
        >
          <span>Jump to: </span>How to Sublimate on <span style={{color:'#241F5F'}}><strong>Cardboard</strong></span>
        </button>
      </div>

      {/* Prep Section */}
      <div className='prep-step'>
        <div className='pre-press'>
          <h2>Prep Process Tips</h2>
          <p>
            Prime the spray bottle by spraying the solution into the sink. This removes air from the tube and helps create a consistent mist. Once you see a fine mist forming, you're ready to go. Need help? <a href='https://sublisnap.com/contact' target='_blank' rel='noopener noreferrer'>Contact us here</a>.
          </p>

          <div className='tips-container'>
            <h2>Tips for Best Results</h2>
            <ul>
              <li>Ensure the fabric is completely dry before pressing</li>
              <li>Use gloves if you have sensitive skin</li>
              <li>Experiment with different heat press settings</li>
              <li>Test on a scrap piece before your final press</li>
              <li>Many issues are caused by unclear instructions. If you’re unsure, reach out or comment with your results—we’re here to help!</li>
            </ul>
          </div>

          <div className='spray-bottle-care'>
            <h2>Spray Bottle Care</h2>
            <p>
              After each use, flush the spray head with clean water. Fill a glass with water, dip the sprayer tube inside, and pump until it sprays clear. Then spray out any remaining water.
            </p>
            <p>
              <strong>If your sprayer is jammed:</strong> Soak it in near-boiling water for 5 minutes, then spray the hot water through until the mist returns. A clogged head can cause an uneven stream, which will affect your results.
            </p>
          </div>
        </div>

        {/* Video */}
        <div className='youtube-video' style={{ margin: '2rem 0' }}>
          <iframe
            width='100%'
            height='300px'
            src='https://www.youtube.com/embed/xKnXlZ2Va4U?si=2_dUF_Z4CZzYwRZR'
            title='YouTube video player'
            frameBorder='0'
            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
            allowFullScreen
            style={{ borderRadius: '8px', maxWidth: '560px', display: 'block', margin: '0 auto' }}
          />
        </div>

        {/* Materials */}
        <div className='materials'>
          <h2>Materials Needed</h2>
          <ul>
            <li>SubliSnap spray</li>
            <li>Cotton fabric (t-shirts, bags, etc.)</li>
            <li>Sublimation printer and ink</li>
            <li>Sublimation paper</li>
            <li>Heat press</li>
            <li>Lint roller</li>
            <li>Heat-resistant tape</li>
            <li>Optional: gloves</li>
          </ul>
        </div>
      </div>

      {/* Cotton Shirt Instructions */}
      <div className='how-to-container' style={{ marginTop: '3rem' }}>
        <h1 style={{ fontSize: '1.5rem' }}>How to Sublimate on Cotton Shirts</h1>
        <div className='heat-settings'>
          <h2>Heat Settings</h2>
          <p>Temperature: 375°F</p>
          <p>Time: 45 Seconds</p>
        </div>
        <div className='instructions-container'>
          <ul>
            <li>Lint roll the design area</li>
            <li>Unlock and prime the sprayer until it mists</li>
            <li>Hold at a 45° angle and spray lightly over the area</li>
            <li>The fabric should feel damp but not soaked</li>
            <li>Let it air dry or gently pre-dry under press (without pressure)</li>
            <li>Place design, press at 375°F for 45 seconds</li>
            <li>Cold peel after pressing</li>
            <li>Wash in cold water with no detergent or softener on the first wash</li>
          </ul>
        </div>
      </div>

      {/* Cardboard Instructions Section */}
      <div className='how-to-container' id='cardboard-instructions' style={{ marginTop: '4rem', backgroundColor: '#f9f9f9', padding: '2rem', borderRadius: '10px' }}>
        <h1 style={{ fontSize: '1.5rem', color: '#333' }}>How to Sublimate on Cardboard</h1>
        <p style={{ color: '#555', marginBottom: '1.5rem' }}>
          Sublimating on cardboard is very similar to sublimating on shirts — except cardboard absorbs the solution instantly. That means you’ll need to wipe off the excess right after spraying.
        </p>
        <ul className='instructions-container' style={{ paddingLeft: '1.5rem', display: 'flex', gap: '1rem', flexWrap: 'wrap'}}>
          <li>Lightly spread the area with SubliSnap cardboard solution.</li>
          <li>Immediately wipe the surface gently with a paper towel — don’t skip this!</li>
          <li>Let it dry completely, either air drying or carefully drying with a press (no pressure)</li>
          <li>Apply your sublimation design and press as usual (375°F, 45 sec)</li>
          <li>Let it cool before peeling</li>
        </ul>
        <p style={{ marginTop: '1rem', fontStyle: 'italic', color: '#666' }}>
          Cardboard doesn’t need to be soaked — a small amount of coating goes a long way!
        </p>
      </div>
    </section>
  )
}

export default Instructions
